import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import config from '../../config';
import { getI18n } from 'react-i18next';
import { isValidJSON } from '../../utils/formatName';

class GridTranslatableCell extends Component {
    render() {
        const rawValue = this.props.value;
        const i18CurrentLanguage = getI18n().language || config.language;

        let displayText = '';

        const isString = typeof rawValue === 'string';
        const isObject = rawValue !== null && rawValue !== undefined && typeof rawValue === 'object';

        let parsed = null;
        if (isString && isValidJSON(rawValue)) {
            try {
                parsed = JSON.parse(rawValue);
            } catch (e) {
                parsed = null;
            }
        }

        const source = (parsed && typeof parsed === 'object') ? parsed : (isObject ? rawValue : null);

        if (source) {
            displayText = source[i18CurrentLanguage] || source[config.language] || '';
        } else if (isString && rawValue !== null && rawValue !== undefined) {
            displayText = rawValue;
        }

        return (
            <TableCell key={this.props.field.id} align="left">
                {displayText}
            </TableCell>
        );
    }
}

export default GridTranslatableCell;
